import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { ApiResponse, SecretDetails, ViewSecretRequest } from '@/types';

const getApiBaseUrl = (): string => {
    const viteMode = import.meta.env.MODE;
    const apiBaseUrlFromEnv = import.meta.env.VITE_API_BASE_URL;

    if (viteMode === 'development') return '/api/v1';

    return apiBaseUrlFromEnv || 'https://pro-api.sharepass.com/v1';
};

const API_BASE_URL = getApiBaseUrl();

export const secretApi = createApi({
    reducerPath: 'secretApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE_URL,
        prepareHeaders: (headers) => {
            return headers;
        },
    }),
    endpoints: (builder) => ({
        viewSecret: builder.query<ApiResponse<SecretDetails>, ViewSecretRequest>({
            query: ({ secretId, pin, challengeresponse, emailGuess, emailVerificationCode, captchaToken }) => {
                const headers: Record<string, string> = {};

                if (pin) headers.pin = pin;
                if (challengeresponse) headers.challengeresponse = challengeresponse;
                if (emailGuess) headers.emailGuess = emailGuess;
                if (emailVerificationCode) headers.emailCode = emailVerificationCode;
                if (captchaToken) headers['X-Captcha-Token'] = captchaToken;

                return {
                    url: `/secret/view`,
                    method: 'GET',
                    params: { secretId },
                    headers,
                };
            },
        }),
    }),
});

export const { useViewSecretQuery, useLazyViewSecretQuery } = secretApi;
